import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { TrendingUp, CheckCircle } from 'lucide-react';
import { hasPIAccess } from '../../lib/permissions';
import './PILockedPage.css';

export default function PILockedPage({ currentUser }) {
  const navigate = useNavigate();

  // If user already has PI access, redirect to dashboard
  if (hasPIAccess(currentUser)) {
    return <Navigate to="/pi/dashboard" replace />;
  }

  return (
    <div className="pi-locked-page">
      {/* Blurred dashboard preview */}
      <div className="pi-locked-preview" aria-hidden="true">
        <div className="pi-locked-preview-inner">
          <div className="pi-preview-stat-row">
            {['Weighted IRR', 'VCP Initiatives', 'Add-Ons', 'Needing Attention'].map(label => (
              <div key={label} className="pi-preview-stat">
                <div className="pi-preview-number" />
                <div className="pi-preview-label">{label}</div>
              </div>
            ))}
          </div>
          <div className="pi-preview-table">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="pi-preview-row">
                {[...Array(6)].map((_, j) => (
                  <div key={j} className="pi-preview-cell" style={{ width: `${[22, 12, 10, 14, 14, 14][j]}%` }} />
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="pi-locked-blur" />
      </div>

      {/* Upgrade CTA overlay */}
      <div className="pi-locked-cta">
        <div className="pi-locked-icon">
          <TrendingUp size={28} />
        </div>
        <h2 className="pi-locked-headline">Turn your closed deals into managed returns</h2>

        <ul className="pi-locked-benefits">
          <li>
            <CheckCircle size={16} />
            <span>Track every value creation initiative against what you underwrote</span>
          </li>
          <li>
            <CheckCircle size={16} />
            <span>Live IRR and EBITDA modeling — updated as your portcos perform</span>
          </li>
          <li>
            <CheckCircle size={16} />
            <span>Exit readiness scoring from close to sale</span>
          </li>
        </ul>

        <div className="pi-locked-actions">
          <button
            className="pi-locked-upgrade-btn"
            onClick={() => navigate('/settings')}
          >
            Upgrade Plan
          </button>
          <a
            className="pi-locked-talk-btn"
            href="https://cal.com/dealnexa"
            target="_blank"
            rel="noopener noreferrer"
          >
            Talk to Us
          </a>
        </div>
      </div>
    </div>
  );
}
